var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"monitor-player",attrs:{"autoplay":"","controls":"","src":_vm.stream.hls}})}
var staticRenderFns = []

export { render, staticRenderFns }